import * as R from 'ramda'

import { FILE_UPLOAD_STATUS } from '../../constants'

export const getIsUploading = R.pipe(
  R.path(['fileState', 'entities', 'files']),
  R.values,
  R.pluck('status'),
  R.includes(FILE_UPLOAD_STATUS.FILE_UPLOAD_IN_PROGRESS)
)
